<template>
  <section>
    <div class="container z-grid v-page-section-container-padding">
      <div v-if="label" class="col-span-full 2xl:col-start-2 2xl:col-end-12 sm:flex flex-row items-center justify-between leading-none mb-4 sm:mb-6">
        <h2 class="flex-auto text-xl sm:text-2xl lg:text-3xl font-semibold text-app-primary-1-red--fire-brick" :class="{ 'mb-2 sm:mb-0': buttonUrl }">{{ label }}</h2>
        <MoleculeButton v-if="buttonUrl" :url="buttonUrl" :enable-icon-left="false" size="small" class="md:hidden">
          {{ buttonTitle }}
        </MoleculeButton>
        <MoleculeButton v-if="buttonUrl" :url="buttonUrl" :enable-icon-left="false" size="large" class="hidden md:block">
          {{ buttonTitle }}
        </MoleculeButton>
      </div>
    </div>
    <div :class="{ 'pb-4 sm:pb-6 border-b border-app-primary-grey--black-squeeze': shelfBorder }">
      <MoleculeDiscoveryCarousel :items="entries" :slides-visible="slidesVisible" :portrait="portrait" />
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  label: { type: String, required: false, default: undefined },
  slidesVisible: { type: Number, required: false, default: 2 },
  portrait: { type: Boolean, required: false, default: false },
  entries: { type: Array as PropType<any[]>, required: true },
  buttonTitle: { type: String, required: false, default: undefined },
  buttonUrl: { type: String, required: false, default: undefined },
  shelfBorder: { type: Boolean, required: false, default: true },
})
</script>
